import { QueryClient } from "@tanstack/react-query";
import { isAxiosError, isCancel } from "axios";

export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
    if (failureCount >= 1 || isCancel(error) || !isAxiosError(error)) return false;
    const status = error.response?.status;
    return status === undefined || (status >= 500 && status < 600);
}

export const queryClient: QueryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 15_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            retry: shouldRetryQuery,
            retryDelay: 1_000,
        },
    },
});

/**
 * Relatórios e Dashboard ficam "frescos" por 3 minutos, em vez dos 15 segundos
 * do resto (F8 do plano de desempenho).
 *
 * As invalidações locais em `services/queryInvalidation.ts` antecipam a
 * atualização dos grupos afetados. Escritas de outros usuários/dispositivos
 * dependem da próxima consulta: o prazo não garante atualização em tempo real.
 *
 * Não reutilizar dados de outra chave como placeholder global: a chave pode
 * mudar por troca de fazenda ou relatório, não apenas de filtro. Refetch da
 * mesma chave já preserva seu próprio resultado enquanto atualiza.
 * Quem precisa de dado sempre novo (previsão de estoque) continua declarando
 * `staleTime: 0` na própria consulta, que tem prioridade sobre este padrão.
 */
const REPORT_STALE_TIME = 3 * 60_000;

for (const prefix of [["dashboard"], ["reports-hub"], ["report"]]) {
    queryClient.setQueryDefaults(prefix, {
        staleTime: REPORT_STALE_TIME,
    });
}
